import './App.css';
import Navbar from './Navbar'
import ProductsList from './ProductList'

function App() {
  return (
    <div >
      <Navbar />
      <ProductsList />
    </div>
  );
}

export default App;
